import { render, staticRenderFns } from "./CreateEditPaymentMethod.vue?vue&type=template&id=2b035cd2&scoped=true"
import script from "./CreateEditPaymentMethod.vue?vue&type=script&lang=js"
export * from "./CreateEditPaymentMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b035cd2",
  null
  
)

export default component.exports